import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import {Nav, Platform, MenuController, AlertController, App, ModalController, Tabs } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DomSanitizer} from '@angular/platform-browser';


// RxJS
import { ReplaySubject } from "rxjs/ReplaySubject";
import { ArrayObservable } from "rxjs/observable/ArrayObservable";

// Ionic
import { ImcpaAppProvider } from '../providers/imcpaApp/imcpaApp';
// import { AddUserModal } from '../pages/users/addUser/addUserModal';

// Models
import { SideMenuContentComponent } from './../shared/side-menu-content/side-menu-content.component';
import { SideMenuSettings } from './../shared/side-menu-content/models/side-menu-settings';
import { MenuOptionModel } from './../shared/side-menu-content/models/menu-option-model';

import { TabsPage } from '../pages/tabs/tabs';
import { LoginPage } from '../pages/login/login';
import { FarmListPage } from '../pages/farms/farmList/farmList';

@Component({
  templateUrl: 'app.html',
  encapsulation: ViewEncapsulation.None
})
export class MyApp {

  @ViewChild(Nav) navCtrl: Nav;
	@ViewChild(SideMenuContentComponent) sideMenu: SideMenuContentComponent;

  rootPage:any = TabsPage;

  // Options to show in the SideMenuComponent
  public options: Array<MenuOptionModel>;

	// Settings for the SideMenuComponent
	public sideMenuSettings: SideMenuSettings = {
		accordionMode: true,
		showSelectedOption: true,
		selectedOptionClass: 'my-selected-option',
    subOptionIndentation: {
      md: '56px',
      ios: '64px',
      wp: '56px'
    }
  };
  
  public check = 'true';

  private unreadCountObservable: any = new ReplaySubject<number>(0);

  public myreturnvalue;
  public loading;

  constructor(
    private statusBar: StatusBar,
    private splashScreen: SplashScreen,
    private sanitizer: DomSanitizer,
    private platform: Platform,
    private alertCtrl: AlertController,
    private menuCtrl: MenuController,
    public app: App,
    public myApp: ImcpaAppProvider,
    public modalCtrl: ModalController) {

      this.initializeApp();

  }

  initializeApp() {
		this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.initializeOptions();
		});		
  }
  

  private initializeOptions(): void {
		this.options = [{
			iconName: 'ios-home',
			displayName: 'Home',
			component: TabsPage,
			index: 0,
			// This option is already selected
			selected: true
		},
    {
			iconName: 'ios-leaf',
			displayName: 'Farms',
      // badge: sdfdfljdsf,
			component: FarmListPage,
      
      index: undefined,
		},
    {
			iconName: 'md-globe',
			displayName: 'Global',
			component: TabsPage,
      index: 1,
		},
    // {
	// 		iconName: 'information-circle',
	// 		displayName: 'About',
	// 		component: TabsPage,
    //   index: 2
	// 	},
    // {
	// 		iconName: 'contacts',
	// 		displayName: 'Contact',
	// 		component: TabsPage,
    //   index: 3
	// 	},


    // {
		// 	displayName: 'Asset Management',
		// 	subItems: [
		// 		{
		// 			iconName: 'basket',
		// 			displayName: 'Stock',
		// 			component: DetailsPage
		// 		},
		// 		{
		// 			iconName: 'bookmark',
		// 			displayName: 'License',
		// 			component: LicenseListPage,
    //       index: undefined
		// 		},
    //     {
		// 			iconName: 'bug',
		// 			displayName: 'contract',
		// 			// badge: this.unreadCountObservable,
		// 			component: DetailsPage
		// 		},
		// 		{
		// 			iconName: 'bookmark',
		// 			displayName: 'Fines',
		// 			component: DetailsPage
		// 		},
		// 	]
		// },

    // {
		// 	iconName: 'apps',
		// 	displayName: 'Asset Management',
		// 	component: DetailsPage
		// },
    // {
		// 	iconName: 'bowtie',
		// 	displayName: 'dkjflsjka',
		// 	badge: ArrayObservable.of('NEW'),
		// 	component: DetailsPage
		// },
    ,{
			displayName: 'Log Out',
			subItems: [
				// {
				// 	iconName: 'log-in',
				// 	displayName: 'Login',
				// 	custom: {
				// 		isLogin: true
				// 	}
				// },
				{
					iconName: 'log-out',
					displayName: 'Logout',
					custom: {
						isLogout: true
					}
				},
				// {
				// 	iconName: 'globe',
				// 	displayName: 'Open Google',
				// 	custom: {
				// 		isExternalLink: true,
				// 		externalUrl: 'http://www.google.com'
				// 	}
				// }
			]
		}]
	}
  public selectOption(option: MenuOptionModel): void {
		this.menuCtrl.close().then(() => {

			if (option.custom && option.custom.isLogin) {
				this.presentAlert('You\'ve clicked the login option!');
			} else if (option.custom && option.custom.isLogout) {
				this.presentAlert('You\'ve clicked the logout option!');
			} else if(option.custom && option.custom.isExternalLink) {
				let url = option.custom.externalUrl;
				window.open(url, '_blank');
			} else if(this.navCtrl.getActiveChildNavs() && option.index != undefined){
        let nav = this.app.getRootNavs()[0]; 
          nav.setRoot(option.component, {tabIndex: option.index});
      } 
      // else if(!option.index) {
			// 	// Redirect to the selected page
			// 	this.app.getActiveNavs()[0].setRoot(DetailsPage, { 'title': option.displayName });
			// } 
      else {
        this.app.getActiveNavs()[0].setRoot(option.component, { tabIndex: option.index, 'title': option.displayName });
      }
		});
	}

	public collapseMenuOptions(): void {
		// Collapse all the options
		this.sideMenu.collapseAllOptions();
	}
	

	public presentAlert(message: string): void {
		let alert = this.alertCtrl.create({
			title: 'LogOut',
			message: 'Are Sure You Want to Log Out',
			buttons: [ {
          text: 'Cancel',
          handler: () => {
          }
        },
        {
          text: 'Yes',
          handler: () => {
			this.myApp.access = {};
			this.myApp.isLoggedIn = false;
            this.navCtrl.setRoot(TabsPage)
          }
        }]
		});
		alert.present();
	}

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts